module.exports = __webpack_public_path__ + "app/img/rocketstar.be888f115a.svg";